import MainLayout from "../components/layout/MainLayout";
import ModalLoadingFull from "../components/modals/ModalLoadingFull";
import { findGetParameter } from "../components/utilities/UtilityFunctions";
import { getEnvironmentVariable } from "../global/environmentVariables";
import StoreCart from "../pages/store/StoreCart";
import StoreCheckout from "../pages/store/StoreCheckout";
import StoreIndex from "../pages/store/StoreIndex";
import StoreOrder from "../pages/store/StoreOrder";
import StoreProduct from "../pages/store/StoreProduct";
import LoginRedirect from "../pages/user/Login/LoginRedirect";
import NotFound from "../pages/utility/NotFound";

export const shopRoutes = (authContext, itemsMiddle, setItemsMiddle) => {
  const forceLoginParam = findGetParameter("forceLogin");

  let _children1 = [];
  let _children2 = [];

  if (getEnvironmentVariable("SUPPORTS_PRODUCTS") === "true") {
    _children2.push({
      path: "product/:productId",
      element:
        getEnvironmentVariable("SUPPORTS_LOYALTY_STORE") !== "true" &&
        getEnvironmentVariable("SUPPORTS_PRODUCTS") !== "true" ? (
          <NotFound />
        ) : (
          <StoreProduct />
        ),
    });
  }
  if (getEnvironmentVariable("SUPPORTS_LOYALTY_STORE") === "true") {
    _children1.push(
      {
        path: "cart",
        element: <StoreCart />,
      },
      {
        path: "checkout",
        element: authContext?.authState?.isAuthenticated ? (
          <StoreCheckout />
        ) : (
          <LoginRedirect />
        ),
      },
      {
        path: "transaction/:transactionId",
        element: authContext?.authState?.isAuthenticated ? (
          <StoreOrder />
        ) : (
          <LoginRedirect />
        ),
      }
    );

    _children2.push({
      path: "/shop/",
      element: <StoreIndex />,
    });
  }

  let _routes = [];

  if (_children1.length > 0) {
    _routes.push({
      path: "shop",
      element:
        !authContext?.authState || authContext?.authState?.isLoading ? (
          <ModalLoadingFull />
        ) : forceLoginParam?.toLowerCase() === "true" &&
          !authContext?.authState?.isAuthenticated ? (
          <LoginRedirect />
        ) : (
          <MainLayout
            authContext={authContext}
            itemsMiddle={itemsMiddle}
            setItemsMiddle={setItemsMiddle}
          />
        ),
      children: _children1,
    });
  }

  if (_children2.length > 0) {
    _routes.push({
      path: "shop",
      element:
        !authContext?.authState || authContext?.authState?.isLoading ? (
          <ModalLoadingFull />
        ) : forceLoginParam?.toLowerCase() === "true" &&
          !authContext?.authState?.isAuthenticated ? (
          <LoginRedirect />
        ) : (
          <MainLayout
            storePage={
              getEnvironmentVariable("SUPPORTS_LOYALTY_STORE") === "true"
            }
            authContext={authContext}
            itemsMiddle={itemsMiddle}
            setItemsMiddle={setItemsMiddle}
          />
        ),
      children: _children2,
    });
  }

  return _routes;
};
